var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cta-banner',{attrs:{"title":_vm.$route.name}}),(_vm.informacion.titulo)?_c('cta-description',{staticClass:"py-20",attrs:{"descripcion":_vm.informacion,"isImage":true,"hasLink":true,"patrocinar":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }